import { useState, useEffect, useRef } from "react";
 
 
import reviewPng from "../review.png";
import Config from "../Config";


function MediaBrowser(props)
{

    var rImg = reviewPng;
    if(props.review != undefined)
    {
         if(props.review.includes("data:"))
         {
            rImg =  props.review;
         }else 
         rImg = "data:image/jpeg;base64, " + props.review;
    }
    const [reviewImg, setReviewImg] = useState(rImg);


    const downloadLink = useRef(null);

    
    const[typ,setTyp] = useState(props.typ);
    const[typId,setTypId] = useState(props.typId);

    var defCrypt = "";
    if(props.crypt != undefined) defCrypt = props.crypt;
    const[crypt,setCrypt] = useState(defCrypt);
 
    const [tab, setTab] = useState(null);

    const [view, setView] = useState("normal");

    const [selectedInx, setSelectedInx] = useState(0);


    const changeView = () => {
        if(view == "normal") 
             { 
               
                   setView("browser");                   
             } else setView("normal");
    }




    const goBack = () => {
        if(selectedInx > 0) 
        {
          setSelectedInx( selectedInx-1 );
        }else 
        setSelectedInx( tab.result.length - 1 );
    }

    const goNext = () => {
        if(selectedInx < tab.result.length - 1) 
        {
        setSelectedInx( selectedInx+1 );
        }else  setSelectedInx( 0 );
    }

    const goClose = () => {
        setView("normal");
        console.log("cloesdfsdf");
    }



    const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
      
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
      
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
      
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
          
        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
      }



    const goDownload = (e) => {

            var inx = e.target.getAttribute('atr-inx');            


            var b64 = tab.result[inx].b64;
            var typx = tab.result[inx].typ;
            var url = tab.result[inx].url;
            var nazwa = tab.result[inx].nazwa;

            if(typx == 'mp4')
            {                                          
            }


      
 

            const blob = b64toBlob(b64, '');
            const blobUrl = URL.createObjectURL(blob);

            //window.location = blobUrl;
            //window.open(blobUrl,'_blank');

            var anchor = document.createElement('a');
            anchor.href = blobUrl;
            anchor.target = '_blank';
            anchor.download = nazwa;
            anchor.click();

      
    }


    const getData = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            typ: typ,
            typId: typId,
            crypt:crypt,
        };

        fetch( Config.url + '/rest_v1,get_medias', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res);              
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    var browser = null;

    if(view == "browser"   )   
    {

        try{

                if(tab == null)
                {
                    setTab([]);
                    getData();                      
                }


              
                if( tab != null && tab._sys_ != undefined && tab.result != undefined && tab.result.length > 0 )
                    {
                        var b64 = tab.result[selectedInx].b64;
                        var typx = tab.result[selectedInx].typ;
                        var url = tab.result[selectedInx].url;

                        browser = <div className="wall_browser">

                                    <div className="tools shadowx">
                                            <span className="tLink" onClick={goBack}>← wstecz</span>
                                            <span className="tLink" onClick={goClose}>zamknij</span>
                                            <span className="tLink" onClick={goNext}>dalej →</span> 
                                    </div>
                                    <div className="center_img">

                                        <div className="number_img">{ (selectedInx+1) } z {tab.result.length}</div>

                                        {
                                            (typx == "jpg" || typx == "jpeg" || typx == "png") &&
                                            <img   src={ "data:image/jpeg;base64, " + b64 } className="shadowx img_browser"  title={"inx" + selectedInx} onClick={goNext} />
                                        }                                       

                                        {
                                            (typx == "mp4"  ) &&
                                            <video  controls="controls" src={url}  className="shadowx vid_browser" >
                                            </video>  
                                        }

                                        {
                                            typx == "pdf" &&                                            
                                                <iframe src={"data:application/pdf;base64," + b64}   className="frame_pdf"></iframe>
                                            
                                        }

                                        {
                                               ((typx == "jpg" || typx == "jpeg" || typx == "png" || typx == "mp4" || typx == "pdf")) &&
                                               <span>
                                                Nieznany plik
                                               </span>
                                        }

                                        <div className="number_img xdownload" atr-inx={selectedInx} onClick={goDownload}> Pobierz ten plik <a href="#" ref={downloadLink} target="_blank"></a> </div>
                                        
                                    </div>

                                
                        

                            </div>
                    }

        } catch (e) {
            console.log("ErrorMediaBrowser ", e);
        }
    }


    var defClass = "";
    if(props.className != undefined) defClass = props.className;


    return <div className="media_browser">
                <img src={rImg} onClick={changeView} className={defClass} />
                {browser}
    </div>
}



export default MediaBrowser;